import { Platform } from 'react-native'

import { APP_NAME } from '@zet/end-points'

const isCustomerFlow = () => {
  if (APP_NAME === 'my-teams') {
    return false
  }

  if (Platform.OS === 'web') {
    return true
  }

  return false
}

export { isCustomerFlow }
